<template>
  <v-card>
    <v-card-title class="justify-center">
        <h2>
          {{ categoria ? 'EDITAR CATEGORIA' : 'ADICIONAR CATEGORIA' }}
        </h2>
    </v-card-title>
    <v-divider></v-divider>
    <v-container flex>
      <v-form lazy-validation v-model="valid" ref="formCombustivel">
        <v-layout row wrap fill-height justify-space-between>
            <v-flex xs12>
                <v-text-field
                  label="Nome"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosCategoria.nome"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex xs12>
                <v-text-field
                  label="Referência"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosCategoria.referencia"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex sm12>
              <v-select
                :items="icones"
                v-model="dadosCategoria.icone"
                label="Icone"
                single-line
              >
                <template slot="selection" slot-scope="data">
                  <v-flex xs2>
                    <v-avatar color="grey" size="25px">
                      <v-icon>{{data.item.value}}</v-icon>
                    </v-avatar>
                  </v-flex>
                  <v-flex class='ml-1'>
                    {{ data.item.text }}
                  </v-flex>
                </template>
                <template slot="item" slot-scope="data">
                  <v-list-tile-avatar color="grey">
                    <v-icon>{{data.item.value}}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ data.item.text }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12>
              <strong>Escolha uma cor base:</strong>
              <swatches v-model="dadosCategoria.cor" inline/>
            </v-flex>
            <v-flex xs12>
                <v-textarea
                  label="Descrição"
                  hint="Descrição da categoria"
                  v-model="dadosCategoria.descricao"
                >
                </v-textarea>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
        <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="info" @click="inserirCategoria()">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Swatches from 'vue-swatches'

export default {
  components: { Swatches },
  props: ['categoria'],
  data () {
    return {
      valid: false,
      dadosCategoria: {
        nome: null,
        icone: null,
        cor: null,
        descricao: null,
        referencia: null
      },
      icones: [
        {
          text: 'Bomba de Combustível',
          value: 'local_gas_station'
        },
        {
          text: 'Suporte',
          value: 'support'
        },
        {
          text: 'Gota de Água',
          value: 'water_drop'
        },
        {
          text: 'Barril de Óleo',
          value: 'oil_barrel'
        },
        {
          text: 'Óleo',
          value: 'invert_colors'
        },
        {
          text: 'Controle',
          value: 'sports_esports'
        },
        {
          text: 'Martelo e Chave',
          value: 'construction'
        },
        {
          text: 'Cabide',
          value: 'checkroom'
        },
        {
          text: 'Livro',
          value: 'book'
        },
        {
          text: 'Bicicleta',
          value: 'directions_bike'
        },
        {
          text: 'Bateria',
          value: 'battery_charging_full'
        },
        {
          text: 'Garfo e Faca',
          value: 'restaurant'
        },
        {
          text: 'Carro',
          value: 'directions_car'
        },
        {
          text: 'Bebida',
          value: 'local_drink'
        },
        {
          text: 'Gás',
          value: 'whatshot'
        },
        {
          text: 'Engrenagem',
          value: 'settings'
        }
      ]
    }
  },
  beforeMount () {
    if (this.categoria) {
      this.dadosCategoria = this.categoria
    }
  },
  methods: {
    fechar () {
      this.$refs.formCombustivel.reset()
      this.$emit('carregar')
      this.$emit('fechar')
    },
    inserirCategoria () {
      if (this.$refs.formCombustivel.validate()) {
        this.$store.dispatch('categorias', {
          method: this.categoria ? 'PUT' : 'POST',
          id: this.categoria ? this.categoria.id : undefined,
          body: this.dadosCategoria
        }).then(() => {
          this.$emit('info', 'Categoria cadastrada com sucesso.')
          this.fechar()
        })
      }
    }
  }
}
</script>
